import script from "./today.vue?vue&type=script&setup=true&lang=js"
export * from "./today.vue?vue&type=script&setup=true&lang=js"

import "./today.vue?vue&type=style&index=0&id=49bf8475&lang=less&scoped=true"

import exportComponent from "D:\\workspace\\payment-system-merchant\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49bf8475"]])

export default __exports__